<div slot="content" class="h-100 p-2">
  <div class="h-100 w-100 mx-auto">
    <dx-data-grid id="gridContainer"
                  class="h-100"
                  [dataSource]="ValidFeatures"
                  [allowColumnReordering]="true"
                  [rowAlternationEnabled]="true"
                  [allowColumnResizing]="true"
                  [showBorders]="true">
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxi-column dataField="name" caption="{{ 'Name' | translate }}"></dxi-column>
      <dxi-column dataField="unit" caption="{{ 'Einheit' | translate }}"></dxi-column>
      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
      <div *dxTemplate="let validFeature of 'detail'">
        <validFeatureValue [validFeature]="validFeature.data" class="flex-fill overflow-hidden"></validFeatureValue>
      </div>
    </dx-data-grid>
  </div>
</div>
